var ServiceHandle;
(function (ServiceHandle) {
    ServiceHandle["ACCOUNT_SERVICE"] = "ACCOUNT_SERVICE";
    ServiceHandle["BILLING_SERVICE"] = "BILLING_SERVICE";
    ServiceHandle["BEAN_COUNTER_SERVICE"] = "BEAN_COUNTER_SERVICE";
    ServiceHandle["COMMITTEE_SERVICE"] = "COMMITTEE_SERVICE";
    ServiceHandle["COMMUNICATION_SERVICE"] = "COMMUNICATION_SERVICE";
    ServiceHandle["EVENT_SERVICE"] = "EVENT_SERVICE";
    ServiceHandle["FORMS_SERVICE"] = "FORMS_SERVICE";
    ServiceHandle["GOVT_AFFAIRS_SERVICE"] = "GOVT_AFFAIRS_SERVICE";
    ServiceHandle["MEMBER_SERVICE"] = "MEMBER_SERVICE";
    ServiceHandle["REPORTING_SERVICE"] = "REPORTING_SERVICE";
    ServiceHandle["UTILITIES_SERVICE"] = "UTILITIES_SERVICE";
    ServiceHandle["EMAIL_SERVICE"] = "EMAIL_SERVICE";
    ServiceHandle["STATE_EDUCATION_SERVICE"] = "STATE_EDUCATION_SERVICE";
})(ServiceHandle || (ServiceHandle = {}));

var Timezone;
(function (Timezone) {
    Timezone["US_Alaska"] = "US/Alaska";
    Timezone["US_Aleutian"] = "US/Aleutian";
    Timezone["US_Arizona"] = "US/Arizona";
    Timezone["US_Central"] = "US/Central";
    Timezone["US_EastIndiana"] = "US/East-Indiana";
    Timezone["US_Eastern"] = "US/Eastern";
    Timezone["US_Hawaii"] = "US/Hawaii";
    Timezone["US_IndianaStarke"] = "US/Indiana-Starke";
    Timezone["US_Michigan"] = "US/Michigan";
    Timezone["US_Mountain"] = "US/Mountain";
    Timezone["US_Pacific"] = "US/Pacific";
})(Timezone || (Timezone = {}));

var ApplicationHandle;
(function (ApplicationHandle) {
    ApplicationHandle["SECURITY"] = "SECURITY";
    ApplicationHandle["TANGILLA"] = "TANGILLA";
})(ApplicationHandle || (ApplicationHandle = {}));

var TangillaEntitlements;
(function (TangillaEntitlements) {
    TangillaEntitlements["EVENT_MODULE"] = "EVENT_MODULE";
    TangillaEntitlements["FINANCE_MODULE"] = "FINANCE_MODULE";
    TangillaEntitlements["COMMITTEE_MODULE"] = "COMMITTEE_MODULE";
    TangillaEntitlements["COMMUNICATION_MODULE"] = "COMMUNICATION_MODULE";
    TangillaEntitlements["FORMS_MODULE"] = "FORMS_MODULE";
    TangillaEntitlements["MEMBER_MODULE"] = "MEMBER_MODULE";
    TangillaEntitlements["REPORTING_MODULE"] = "REPORTING_MODULE";
})(TangillaEntitlements || (TangillaEntitlements = {}));

const DateRanges = [
    'Last Week',
    'Week to Date',
    'Last Month',
    'Month to Date',
    'Last Quarter',
    'Quarter to Date',
    'Last Year',
    'Year to Date',
    'Custom'
];

/**
 * Generated bundle index. Do not edit.
 */

export { ApplicationHandle, DateRanges, ServiceHandle, TangillaEntitlements, Timezone };
